//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export class ChatBotHubMethods
{
	public static StartChatStream: string = `ChatBotStartChatStream`;
	public static ReadHistoryStream: string = `ChatBotReadHistoryStream`;
	public static CancelStream: string = `ChatBotCancelStream`;
	public static ReceiveDelta: string = `ChatBotReceiveDelta`;
	public static ReceiveError: string = `ChatBotReceiveError`;
	public static StreamCompleted: string = `ChatBotStreamCompleted`;
	public static HistoryData: string = `ChatBotHistoryData`;
}
